import { ReactElement } from 'react';
import { Stack, StackProps } from '@mui/material';

export type PoolRowProps = StackProps;

export const PoolRow = (props: StackProps): ReactElement => (
    <Stack direction="row" alignItems="center" gap={1} {...props} />
);
